import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import { usePartnerForm } from '../../hooks/usePartnerForm';
import NameField from '@/components/forms/new/formikFormFields/NameField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { FORM_FIELD_PATHS } from '../../constants';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

const PrimaryContactName = ({ darkMode, errors, touched }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { formData, updateFormData } = usePartnerForm();

    const handleChange = (e) => {
        updateFormData(FORM_FIELD_PATHS.PRIMARY_CONTACT_NAME, e.target.value);
    };

    const hasError =
        !!errors?.primaryContactName && touched?.primaryContactName;

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={hasError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Primary Contact Name
                </FormLabel>
                <Box flex={1} maxWidth="400px">
                    <Field
                        component={NameField}
                        id="primaryContactName"
                        name="primaryContactName"
                        value={formData?.primaryContactName || ''}
                        onChange={handleChange}
                        placeholder="Enter primary contact name"
                        width="100%"
                        darkMode={darkMode}
                        isInvalid={hasError}
                        validate={(value) => {
                            if (value && value.length > 100) {
                                return 'Primary contact name must be less than 100 characters';
                            }
                        }}
                    />
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Enter the name of the primary contact person"
                        ariaLabel="primary-contact-name-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default PrimaryContactName;
